<template>
  <div class="messenger">
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      top
      :color="color"
      @input="closeMessage"
    >
      <span
        v-if="getErrorMessage"
        class="messenger__text"
      >{{ getErrorMessage }}</span>
      <span
        v-else
        class="messenger__text"
      >{{ getUserMessage }}</span>
      <v-btn
        dark
        flat
        :color="btnColor"
        @click="snackbar = false"
      >
        Schließen
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      snackbar: false,
      error: false,
      color: '',
      btnColor: '',
      timeout: 5000,
    };
  },
  computed: {
    getErrorMessage() {
      return this.$store.getters.error;
    },
    getUserMessage() {
      return this.$store.getters.message;
    },
  },
  watch: {
    getErrorMessage(val) {
      if (val !== null) {
        this.color = 'error';
        this.btnColor = '';
        this.snackbar = true;
      }
    },
    getUserMessage(val) {
      if (val !== '') {
        this.color = '';
        this.btnColor = 'pink';
        this.snackbar = true;
      }
    },
  },
  methods: {
    closeMessage() {
      this.snackbar = false;
      this.$store.commit('clearError');
      this.$store.commit('clearUserMessage');
    },
  },
};
</script>
